import ModalComponent from 'components/common/ModalComponent';
import { showAlert } from 'services/alerts.service';
import PropTypes from 'prop-types';

const DeviceGroupModal = ({ isOpen, handleSave, handleClose, selectedDevice }) => {
  const handleSaveClick = formData => {
    if (!formData.groupName || formData.groupName.trim() === '') {
      showAlert({
        text: 'Device Group Name is required',
        icon: 'warning'
      });
      return;
    }

    const dataToSave = selectedDevice?.deviceId
      ? { ...formData, deviceId: selectedDevice.deviceId }
      : { ...formData, deviceId: undefined };

    handleSave(dataToSave);
    handleClose();
  };

  return (
    <ModalComponent
      title={selectedDevice?.deviceId ? 'Edit Device Group' : 'New Device Group'}
      isOpen={isOpen}
      onClose={handleClose}
      onSave={handleSaveClick}
      initialData={
        selectedDevice ? { groupName: selectedDevice.groupName || '' } : { groupName: '' }
      }
    >
      {({ formData, handleChange }) => (
        <label className="block text-sm font-medium">
          Device Group Name *
          <input
            type="text"
            name="groupName"
            value={formData.groupName || ''}
            onChange={handleChange}
            className="w-full mt-1 p-2 border rounded"
          />
        </label>
      )}
    </ModalComponent>
  );
};

DeviceGroupModal.propTypes = {
  isOpen: PropTypes.bool,
  handleSave: PropTypes.func,
  handleClose: PropTypes.func,
  selectedDevice: PropTypes.object
};

export default DeviceGroupModal;
